import './index.css';
import { Language } from './language';
import { Level } from './level';
import { UserSentiment } from './user_sentiment';
import { Download } from './download';
import { Share } from './share';
import { ISI } from './isi';
import { Rewind } from "./rewind";
import { ControlsSettings } from './controls_settings' 

export const COMPONENT_MAP = {
    usersentiment: UserSentiment,
    level: Level,
    language: Language,
    download: Download,
    share: Share,
    isi: ISI,
    rewind: Rewind,
    controls_settings: ControlsSettings
}

export { UserSentiment, Download, Share, ISI, Language, Level, Rewind, ControlsSettings }
